export default "__VITE_ASSET__CJsjbRIl__"